import { s, c } from '../../val.config';
import {
  doubleImageElementNewSchema,
  doubleImageElementSchema,
  linksElementSchema,
  singleImageElementSchema,
  textAndImageElementSchema,
  textElementSchema,
} from '../schema/pageElements.val';
import { pageMetadataSchema } from '../schema/pageMetadata.val';

export const schema = s.object({
  header: s.string(),
  ingress: s.richtext({
    style: {
      bold: true,
      italic: true,
      lineThrough: true,
    },
    block: {
      h1: false,
      h2: false,
      h3: true,
      h4: true,
      h5: true,
      h6: true,
      ul: true,
      ol: true,
    },
    inline: {
      a: true,
      img: true,
    },
  }),
  subheader: s.string(),
  pageImage: s.image(),
  pageElements: s.array(
    s.union(
      'type',
      singleImageElementSchema,
      textElementSchema,
      textAndImageElementSchema,
      doubleImageElementSchema,
      doubleImageElementNewSchema,
      linksElementSchema
    )
  ),
  pageMetadata: pageMetadataSchema,
});

export default c.define('/content/pages/om-oss.val.ts', schema, {
  header: 'Om oss',
  ingress: [
    {
      tag: 'p',
      children: [
        'For oss i Blank handler det om å være en partner som jobber med deg. Du skal kunne stole på at vi tar ansvar, løser problemer og faktisk får ting gjort. ',
      ],
    },
    {
      tag: 'p',
      children: [
        'Vi ville utfordre hvordan et konsulentselskap kan fungere og bygge et selskap på tillit, åpenhet og felleskap. Blank er ansatteid og drevet av ønsket om å skape løsninger som betyr noe. Uten konsulentbabbel. Uten tomme løfter.',
      ],
    },
    {
      tag: 'p',
      children: [
        'Gjennom ti år har vi bistått kunder som Ice, Gjensidige, Stortinget, NAV, NRK og Aneo Mobility med å realisere kritiske digitale løsninger. Vi har hjulpet startups som reMarkable, Spacemaker, Oda, Otovo og Take Take Take. Vi verdsetter langvarige kunderelasjoner hvor vi kan gå i dybden og virkelig forstå domenet. Over halvparten av kundene våre har vært med oss i mer enn fem år.',
      ],
    },
  ],
  pageImage: c.image(
    '/public/val/images/dbcb029cf591f7424afeba3f21cbf7f641e704ba-3500x2333.webp',
    {
      width: 3500,
      height: 2333,
      mimeType: 'image/webp',
      alt: 'Fest på loftet',
      hotspot: { x: 0.9005449591280654, y: 0.32906986027944113 },
    }
  ),
  subheader: 'Flinke folk som får ting gjort',
  pageElements: [
    {
      type: 'doubleImageElementNew',
      centered: false,
      layout: 'square-tall',
      image1: c.image('/public/val/bilde03(2)_ebc2d.jpg', {
        width: 3626,
        height: 2532,
        mimeType: 'image/jpeg',
        hotspot: { x: 0.43392370572207084, y: 0.498 },
      }),
      image2: c.image('/public/val/bilde04(2)_fdaaa.jpg', {
        width: 3626,
        height: 2532,
        mimeType: 'image/jpeg',
        hotspot: { x: 0.09666666666666666, y: 0.4176922503169986 },
      }),
      text: 'Vi har kontorer midt i Oslo på  Loftet av Youngstorget i Torggata 15. Et sted hvor vi deler kunnskap, diskuterer ideer eller bare jobber sammen. Vi liker kundene våre og inviterer dem derfor inn for å jobbe sammen med oss.',
    },
    {
      type: 'textElement',
      text: [
        {
          tag: 'p',
          children: [
            'Åpenhet gjennomsyrer alt vi gjør. Vi har en ',
            { tag: 'a', href: '/handboka', children: ['åpen håndbok'] },
            ' der du kan lese om alt fra lønn og fagutvikling til hvordan vi bemanner prosjekter.',
          ],
        },
        {
          tag: 'p',
          children: [
            'I Blank tror vi at åpenhet, tillit og felleskap skaper det beste arbeidsmiljøet.',
          ],
        },
        {
          tag: 'p',
          children: [
            'Vi tror på iterative utviklingsprosesser, tverrfaglige team, designdrevet produktutvikling og brukersentrerte metoder. Og på hverandre. I Blank jobber vi sammen: ikke bare ved siden av hverandre.',
          ],
        },
      ],
      title: 'Blanks filosofi',
    },
    {
      type: 'singleImageElement',
      image: c.image('/public/val/e00c31961b044521d22d2e3e0d3aaec9_fd180.jpg', {
        width: 2048,
        height: 1366,
        mimeType: 'image/jpeg',
        alt: 'Folk i åpent kontorlandskap som jobber fokusert',
      }),
      keepAspectRatio: false,
      clickable: null,
    },
    {
      type: 'linksElement',
      links: [
        { text: 'Bli kjent med folkene våre', href: '/menneskene' },
        { text: 'Les mer om hvordan det er å jobbe i Blank', href: '/jobb' },
        { text: 'Hva kan vi gjøre for deg', href: '/tjenester' },
      ],
    },
  ],
  pageMetadata: {
    title: 'Om Blank',
    description:
      'Vi er et prisvinnende konsulentselskap med 60 dyktige designere og teknologer',
    url: '/om-oss',
    image: c.image(
      '/public/val/images/dbcb029cf591f7424afeba3f21cbf7f641e704ba-3500x2333.webp',
      {
        width: 3500,
        height: 2333,
        mimeType: 'image/webp',
        alt: 'Fest på loftet',
      }
    ),
  },
});
